import {createSelector} from 'reselect';

// Base selector
const getDripCampaignState = state => state.dripCampaign;

// Drip campaign data selectors
export const dripCampaignSelectCampaign = createSelector(
    [getDripCampaignState],
    dripCampaignState => dripCampaignState.dripCampaign
);

// Wizard selectors
export const dripCampaignSelectWizard = createSelector(
    [getDripCampaignState],
    dripCampaignState => dripCampaignState.wizard
);

export const dripCampaignSelectWizardLoading = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.messages.loading || wizard.groups.loading || wizard.senders.loading
);

export const dripCampaignSelectWizardInitialized = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.initialized
);

export const dripCampaignSelectWizardSaving = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.saving
);

// Messages selectors
export const dripCampaignSelectMessages = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.messages.data
);

export const dripCampaignSelectMessagesLoading = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.messages.loading
);

export const dripCampaignSelectMessagesLoaded = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.messages.loaded
);

// Groups selectors
export const dripCampaignSelectGroups = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.groups.data
);

export const dripCampaignSelectGroupsLoading = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.groups.loading
);

export const dripCampaignSelectGroupsLoaded = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.groups.loaded
);

// Senders selectors
export const dripCampaignSelectSenders = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.senders ? wizard.senders.data : []
);

export const dripCampaignSelectSendersLoading = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.senders ? wizard.senders.loading : false
);

export const dripCampaignSelectSendersLoaded = createSelector(
    [dripCampaignSelectWizard],
    wizard => wizard.senders ? wizard.senders.loaded : false
);

// Enrollments selectors
export const dripCampaignSelectEnrollments = createSelector(
    [getDripCampaignState],
    dripCampaignState => dripCampaignState.enrollments.data
);

export const dripCampaignSelectEnrollmentsLoading = createSelector(
    [getDripCampaignState],
    dripCampaignState => dripCampaignState.enrollments.loading
);

export const dripCampaignSelectEnrollmentsLoaded = createSelector(
    [getDripCampaignState],
    dripCampaignState => dripCampaignState.enrollments.loaded
);

// Form field selectors
export const dripCampaignSelectName = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.name
);

export const dripCampaignSelectSubject = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.subject
);

export const dripCampaignSelectMessage = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.message
);

export const dripCampaignSelectTargetGroup = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.targetGroup
);

export const dripCampaignSelectSender = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.sender
);

export const dripCampaignSelectTriggerType = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.triggerType
);

export const dripCampaignSelectDelayInHours = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.delayInHours
);

export const dripCampaignSelectIsActive = createSelector(
    [dripCampaignSelectCampaign],
    campaign => campaign.isActive
);